import { faMountainCity } from "@fortawesome/pro-regular-svg-icons"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import { getActiveAppContext } from "app/tools/common"
import { getEnvironmentList } from "environments/tools/common"
import { formEventModule } from "form/event"
import { FORM_TAB_BOXES, IForm } from "form/model"
import { getEnvironmentsTargetedCount } from "form/tools/environments"
import { refreshEnvironmentList } from "form/tools/environments-forecast"
import React from "react"
import { connect } from "react-redux"
import { EnvironmentsFilter } from "./EnvironmentsFilter"
import { EnvironmentsList } from "./EnvironmentsList"
import { EnvironmentsTree } from "./EnvironmentsTree"
import { ScreensBoxLayout } from "./ScreensBoxLayout"

interface IContentEnvironmentsProps {
  form: IForm
}

interface IContentEnvironmentsConnectProps {
  isTreeView: boolean
}

const ContentEnvironmentsFn = React.memo(
  ({ isTreeView, form }: IContentEnvironmentsProps & IContentEnvironmentsConnectProps): JSX.Element => {
    const isFirstRender = React.useRef(true)
    React.useEffect(() => {
      if (!getActiveAppContext()) {
        return
      }
      if (isFirstRender.current) {
        isFirstRender.current = false
        refreshEnvironmentList()
      }
      formEventModule.on.sspSelectionChanged("component-ContentEnvironments", () => refreshEnvironmentList())
      return () => formEventModule.remove("component-ContentEnvironments")
    }, [form])
    return (
      <ScreensBoxLayout
        id={FORM_TAB_BOXES.SCREENS_ENVIRONMENTS}
        title={translate("environments.title")}
        isLoading={form.screens.isSynchronizingEnvironments}
        total={getEnvironmentList().length}
        selectedCount={getEnvironmentsTargetedCount(form)}
        icon={faMountainCity}
        sxChildren={{
          "height": "calc(100% - 10.5rem)",
          "minHeight": "calc(100% - 10.5rem)",
          "maxHeight": "calc(100% - 10.5rem)",
          "& > *": {
            width: "100%"
          }
        }}>
        <EnvironmentsFilter form={form} isTreeView={isTreeView} />
        {isTreeView ? <EnvironmentsTree form={form} /> : <EnvironmentsList form={form} />}
      </ScreensBoxLayout>
    )
  }
)

export const ContentEnvironments = connect(
  (state: IRootState): IContentEnvironmentsConnectProps => ({
    isTreeView: state.form.isEnvironmentTreeView
  })
)(ContentEnvironmentsFn)
